var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDream4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1345 46.8429C7.65439 27.7095 22.9612 12.4027 51.6614 14.3161C53.5746 43.0161 38.2679 58.323 19.1345 46.8429Z",
    stroke: "url(#paint0_linear_6582_55689)",
    strokeWidth: 4.02016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1836 51.7914L29.4904 36.4846",
    stroke: "url(#paint1_linear_6582_55689)",
    strokeWidth: 4.02016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6582_55689",
    x1: 23.122,
    y1: -1.49813,
    x2: 56.1408,
    y2: 13.8504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577071,
    stopColor: "#EBBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EC85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6582_55689",
    x1: 17.4615,
    y1: 29.9246,
    x2: 31.2999,
    y2: 36.3572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577071,
    stopColor: "#EBBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EC85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDream4);
export default __webpack_public_path__ + "static/media/icon-dream-4.2181569f3303ad01cfeefac7f8085bae.svg";
export { ForwardRef as ReactComponent };